export const touchScroll = `
  -webkit-overflow-scrolling: touch;
  touch-action: manipulation;
`;

export const hideScrollBar = `
  box-sizing: border-box;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  -ms-overflow-style: none;
`;
